<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ReviewCard',
  computed: {
    ...mapGetters({
      disabledSelectAll: 'review/disabledSelectAll',
      disabledDeselectAll: 'review/disabledDeselectAll',
      disabledApproveSelected: 'review/disabledApproveSelected',
      disabledDisapproveSelected: 'review/disabledDisapproveSelected',
    }),
  },
  methods: {
    ...mapActions({
      selectAll: 'review/selectAll',
      deselectAll: 'review/deselectAll',
      approveReviews: 'review/approveReviews',
      disapproveReviews: 'review/disapproveReviews',
      fetchApprovalStatusOverview: 'review/fetchApprovalStatusOverview',
    }),
    confirmApproveReviews() {
      // eslint-disable-next-line no-alert
      if (confirm(this.$t('review.bulkButtons.approveConfirm'))) {
        this.approveReviews()
          .then(() => {
            this.fetchApprovalStatusOverview();
          });
      }
    },
    confirmDisapproveReviews() {
      // eslint-disable-next-line no-alert
      if (confirm(this.$t('review.bulkButtons.disapproveConfirm'))) {
        this.disapproveReviews()
          .then(() => {
            this.fetchApprovalStatusOverview();
          });
      }
    },
  },
};
</script>

<template>
    <v-card class="mb-3 elevation-3">
      <v-card-actions class="justify-center">
        <v-btn
          @click="selectAll"
          :disabled="disabledSelectAll"
          color="primary"
        >
          {{ $t('review.bulkButtons.selectAll') }}
        </v-btn>
        <v-btn
          @click="deselectAll"
          :disabled="disabledDeselectAll"
          color="warning"
        >
          {{ $t('review.bulkButtons.deselectAll') }}
        </v-btn>
        <v-btn
          @click="confirmApproveReviews"
          :disabled="disabledApproveSelected"
          color="success"
        >
          {{ $t('review.bulkButtons.approve') }}
        </v-btn>
        <v-btn
          @click="confirmDisapproveReviews"
          :disabled="disabledDisapproveSelected"
          color="error"
        >
          {{ $t('review.bulkButtons.disapprove') }}
        </v-btn>
      </v-card-actions>
    </v-card>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewBulkButtons.vue